import styled, { css } from 'styled-components';
import { colors, layout, media } from '@prisjakt/ui-base';
import { Link } from 'react-router-dom';

export const Tabs = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: inset 0 -1px 0 0 ${p => p.theme.lines.secondary};

  ${media.mediumDown`
    max-width: 100vh;
    overflow-x: auto;
  `};
`;

type TabProps = {
  active?: boolean;
  to?: string;
};

export const TabLink = styled(Link)<TabProps>(
  props => css`
    padding: ${layout.spacing.small};
    font-weight: 600;
    cursor: pointer;
    color: ${colors.darkGray2};
    transition: box-shadow 0.1s linear;

    a:hover,
    &:hover {
      color: ${colors.darkGray4};
    }

    ${props.active &&
      css`
        box-shadow: inset 0 -5px 0 -1px ${colors.yellow1};
        color: ${p => p.theme.text.primary};

        a:hover,
        &:hover {
          color: inherit;
        }
      `};
  `
);
